import { createAction } from '@reduxjs/toolkit'

import { stateName } from './constants'

export const fetchBannersRequest = createAction(`${stateName}/fetchBannersRequest`)
